// ** MUI Imports
import Box from '@mui/material/Box'

// ** Components
import Autocomplete from 'layouts/components/Autocomplete'
import ModeToggler from 'materialize/layouts/components/shared-components/ModeToggler'
import UserDropdown from 'materialize/layouts/components/shared-components/UserDropdown'
import LanguageDropdown from 'materialize/layouts/components/shared-components/LanguageDropdown'
import NotificationDropdown from 'materialize/layouts/components/shared-components/NotificationDropdown'
import { useAuth } from '@1kit/ui/context/auth'

function AppBarContent(props) {
  // ** Props
  const { hidden, settings, saveSettings } = props
  const { user, logout } = useAuth()

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Autocomplete hidden={hidden} settings={settings} />
      <LanguageDropdown settings={settings} saveSettings={saveSettings} />
      <ModeToggler settings={settings} saveSettings={saveSettings} />
      <NotificationDropdown settings={settings} />
      <UserDropdown settings={settings} user={user} logout={logout} />
    </Box>
  )
}

export default AppBarContent
